/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: /product/black-dashboard-react
* Copyright 2019 SecurePoint 360 ()
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by SecurePoint 360

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { DefaultAvatar } from 'assets';
import classNames from 'classnames';
import React from 'react';
// nodejs library that concatenates classes
// reactstrap components
import {
  // Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  // InputGroup,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  UncontrolledTooltip,
} from 'reactstrap';

import { logOut } from '../../lib/auth';
import { Link } from 'react-router-dom';
class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      modalSearch: false,
      color: 'navbar-transparent',
      prefix: '',
      url: process.env.REACT_APP_DOCS_URL,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.updateColor);
    this.updateModal();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateColor);
  }
  componentDidUpdate(prevProps) {
    if (this.props.brandText !== prevProps.brandText) {
      this.updateModal();
    }
  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.collapseOpen) {
      this.setState({
        color: 'bg-white',
      });
    } else {
      this.setState({
        color: 'navbar-transparent',
      });
    }
  };

  updateModal = () => {
    switch (this.props.brandText) {
      case 'Dashboard':
        this.setState({ prefix: 'dashboard_2' });
        break;
      case 'Dashboard ᴼᴸᴰ':
        this.setState({ prefix: 'dashboard' });
        break;
      case 'Dashboard ᴺᴱᵂ':
        this.setState({ prefix: 'dashboard_2' });
        break;
      case 'Policy Compliance (beta)':
        this.setState({ prefix: 'Policy_Compliance' });
        break;
      case 'PC Findings (beta)':
        this.setState({ prefix: 'PC_Findings' });
        break;
      case 'Vulnerabilities(old)':
        this.setState({ prefix: 'vulnerabilities' });
        break;
      case 'Vulnerabilities':
        this.setState({ prefix: 'vulnerabilities_New' });
        break;
      case 'Web Apps':
        this.setState({ prefix: 'Web_Apps_Page' });
        break;
      case 'Cloud Agents':
        this.setState({ prefix: 'cloud_agent_page' });
        break;
      case 'Endpoints':
        this.setState({ prefix: 'endpoints_page' });
        break;
      case 'SAST':
        this.setState({ prefix: 'SAST_page' });
        break;
      case 'CVE Subscriptions':
        this.setState({ prefix: 'CVE_Subscriptions' });
        break;
      case 'Reports':
        this.setState({ prefix: 'report' });
        break;
      case 'User Profile':
        this.setState({ prefix: 'profile' });
        break;
      case 'Members':
        this.setState({ prefix: 'members' });
        break;
      case 'Settings':
        this.setState({ prefix: 'client_settings' });
        break;
      case 'Release Notes':
        this.setState({ prefix: '' });
        break;
      default:
        this.setState({ prefix: '' });
        break;
    }
  };
  // this function opens and closes the collapse on small devices
  toggleCollapse = () => {
    if (this.state.collapseOpen) {
      this.setState({
        color: 'navbar-transparent',
      });
    } else {
      this.setState({
        color: 'bg-white',
      });
    }
    this.setState({
      collapseOpen: !this.state.collapseOpen,
    });
  };
  // this function is to open the Search modal
  toggleModalSearch = () => {
    this.setState({
      modalSearch: !this.state.modalSearch,
    });
  };
  render() {
    const role = atob(localStorage.getItem(btoa('approle')) || '');
    const settingsPath = `/${role}/settings`;
    return (
      <>
        <Navbar
          className={classNames('navbar-absolute', this.state.color)}
          expand="lg"
        >
          <Container fluid>
            <div className="navbar-wrapper">
              <div
                className={classNames('navbar-toggle d-inline', {
                  toggled: this.props.sidebarOpened,
                })}
              >
                <button
                  id="SideNavMenuIcon"
                  className="navbar-toggler"
                  type="button"
                  onClick={this.props.toggleSidebar}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
              <NavbarBrand href="#" onClick={(e) => e.preventDefault()}>
                <div
                  dangerouslySetInnerHTML={{ __html: this.props.brandText }}
                ></div>
              </NavbarBrand>
              <h4
                className="subtitle"
                style={{ marginLeft: '260px', paddingTop: '15px' }}
                id="page-subtitle"
              >
                {' '}
              </h4>
            </div>
            <button
              aria-expanded={false}
              aria-label="Toggle navigation"
              className="navbar-toggler"
              data-target="#navigation"
              data-toggle="collapse"
              id="navigation"
              type="button"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </button>
            {this.props.headerComponent && (
              <div className="w-100">
                <this.props.headerComponent />
              </div>
            )}
            <Collapse navbar isOpen={this.state.collapseOpen}>
              <Nav className="ml-auto align-items-center" navbar>
                {/* <InputGroup className="search-bar">
                  <Button
                    color="link"
                    data-target="#searchModal"
                    data-toggle="modal"
                    id="search-button"
                    onClick={this.toggleModalSearch}
                  >
                    <i className="tim-icons icon-zoom-split" />
                    <span className="d-lg-none d-md-block">Search</span>
                  </Button>
                </InputGroup> */}
                <NavLink tag="li">
                  <UncontrolledTooltip placement="bottom" target="helpDiv">
                    Help
                  </UncontrolledTooltip>
                  <div
                    id="helpDiv"
                    onClick={(e) => {
                      e.preventDefault();
                      const newWindow = window.open(
                        this.state.url + this.state.prefix,
                        '_blank',
                        'noopener,noreferrer',
                      );
                      if (newWindow) newWindow.opener = null;
                    }}
                    className="navbar-wrapper nav-item"
                    style={{
                      padding: '0.5rem',
                      verticalAlign: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="fa fa-question-circle" />
                  </div>
                </NavLink>
                <NavLink tag="li">
                  <UncontrolledTooltip placement="bottom" target="configDiv">
                    Settings
                  </UncontrolledTooltip>
                  <Link
                    id="configDiv"
                    to={settingsPath}
                    className="navbar-wrapper nav-item"
                    style={{
                      padding: '0.5rem',
                      verticalAlign: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="fa fa-cog" aria-hidden="true"></i>
                  </Link>
                  {/* <div
                    id="configDiv"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href =
                        '/' +
                        atob(localStorage.getItem(btoa('approle'))) +
                        '/settings';
                    }}
                    className="navbar-wrapper nav-item"
                    style={{
                      padding: '0.5rem',
                      verticalAlign: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="fa fa-cog" aria-hidden="true"></i>
                  </div> */}
                </NavLink>
                <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    nav
                    onClick={(e) => e.preventDefault()}
                  >
                    <div className="photo hide-in-small-screen">
                      <img alt="..." src={DefaultAvatar} />
                    </div>
                    <b className="caret d-none d-xl-block hide-in-small-screen" />
                    <section className="d-lg-none nav-item">
                      <NavLink tag="ul">
                        <Link
                          to={`/${role}/user-profile`}
                          style={{ cursor: 'pointer' }}
                        >
                          <DropdownItem
                            className="nav-item"
                            style={{ cursor: 'pointer' }}
                          >
                            <div
                              className="photo"
                              style={{ marginRight: '16px' }}
                            >
                              <img alt="..." src={DefaultAvatar} />
                            </div>
                            <span>PROFILE</span>
                          </DropdownItem>
                        </Link>
                        <DropdownItem divider tag="li" />
                        <DropdownItem
                          className="nav-item"
                          onClick={() => logOut()}
                        >
                          <div
                            className="photo"
                            style={{
                              marginRight: '16px',
                              fontSize: '19px',
                              textAlign: 'center',
                            }}
                          >
                            <span className="tim-icons icon-button-power"></span>
                          </div>
                          <span>LOGOUT</span>
                        </DropdownItem>
                      </NavLink>
                      <DropdownItem
                        divider
                        tag="li"
                        className="hide-in-small-screen"
                      />
                    </section>
                    {/* <p className="d-none d-lg-none nav-item hide-in-small-screen" onClick={() => logOut()}>Log out</p> */}
                  </DropdownToggle>
                  <DropdownMenu
                    className="dropdown-navbar hide-in-small-screen"
                    right
                    tag="ul"
                  >
                    <NavLink tag="li">
                      <Link
                        to={`/${role}/user-profile`}
                        style={{ cursor: 'pointer' }}
                      >
                        <DropdownItem
                          className="nav-item"
                          style={{ cursor: 'pointer' }}
                        >
                          Profile
                        </DropdownItem>
                      </Link>
                    </NavLink>
                    {/* <NavLink tag="li">
                      <DropdownItem className="nav-item">Settings</DropdownItem>
                    </NavLink> */}
                    <DropdownItem divider tag="li" />
                    <NavLink tag="li">
                      <DropdownItem
                        className="nav-item hide-in-small-screen"
                        style={{ cursor: 'pointer' }}
                        onClick={() => logOut()}
                      >
                        Log out
                      </DropdownItem>
                    </NavLink>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <li className="separator d-lg-none hide-in-small-screen" />
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
        <Modal
          modalClassName="modal-search"
          isOpen={this.state.modalSearch}
          toggle={this.toggleModalSearch}
        >
          <div className="modal-header">
            <Input id="inlineFormInputGroup" placeholder="SEARCH" type="text" />
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={this.toggleModalSearch}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
          </div>
        </Modal>
      </>
    );
  }
}

export default AdminNavbar;
